/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconShovel = createReactComponent("outline", "shovel", "IconShovel", [["path", { "d": "M17 4l3 3", "key": "svg-0" }], ["path", { "d": "M18.5 5.5l-8 8", "key": "svg-1" }], ["path", { "d": "M8.276 11.284l4.44 4.44a.968 .968 0 0 1 0 1.369l-2.704 2.704a4.108 4.108 0 0 1 -5.809 -5.81l2.704 -2.703a.968 .968 0 0 1 1.37 0z", "key": "svg-2" }]]);

export { IconShovel as default };
//# sourceMappingURL=IconShovel.mjs.map
